import axios from 'axios';
import { fetchPreLoginRequest, fetchPreLoginSuccess, fetchPreLoginFailure } from '../redux/login/loginAction';
import { fetchUsersFailure } from '../redux/login/loginAction';
import { fetchUsersRequest } from '../redux/login/loginAction';
import { fetchUsersSuccess } from '../redux/login/loginAction';
import { fetchQuestionsFailure } from '../redux/FetchQuestions/QuestionsAction';
import { fetchQuestionsRequest } from '../redux/FetchQuestions/QuestionsAction';
import { fetchQuestionsSuccess } from '../redux/FetchQuestions/QuestionsAction';
import { addQuestionsFailure } from '../redux/AddQuestions/AddQuestionsAction';
import { addQuestionsRequest } from '../redux/AddQuestions/AddQuestionsAction';
import { addQuestionsSuccess } from '../redux/AddQuestions/AddQuestionsAction';
import { eifQuestionsFailure } from '../redux/EifQuestions/EifQuestionsAction';
import { eifQuestionsRequest } from '../redux/EifQuestions/EifQuestionsAction';
import { eifQuestionsSuccess } from '../redux/EifQuestions/EifQuestionsAction';
import { rafQuestionsFailure } from '../redux/RafQuestions/RafQuestionsAction';
import { rafQuestionsRequest } from '../redux/RafQuestions/RafQuestionsAction';
import { rafQuestionsSuccess } from '../redux/RafQuestions/RafQuestionsAction';
import { publishNotificationsFailure, publishNotificationsRequest, publishNotificationsSuccess } from '../redux/AddNotifications/AddNotificationsAction';
import { addNotificationsRequest, addNotificationsFailure, addNotificationsSuccess, deleteNotificationsFailure, deleteNotificationsRequest, deleteNotificationsSuccess } from '../redux/AddNotifications/AddNotificationsAction';
import { addQuestionsCategoryFailure, addQuestionsCategoryRequest, addQuestionsCategorySuccess } from '../redux/AddQuestionsCategory/AddQuestionsCategoryAction';
import {
    downloadKidreportsFailure, downloadKidreportsRequest, downloadKidreportsSuccess, requestKidreportsListRequest,
    requestKidreportsListSuccess, requestKidreportsListFailure, addKidreportsFailure, addKidreportsRequest, addKidreportsSuccess, deleteKidreportsFailure, deleteKidreportsRequest, deleteKidreportsSuccess, publishKidreportsFailure, publishKidreportsRequest, publishKidreportsSuccess
} from '../redux/AddKidReport/AddKidReportAction';
import { fetchQuestionscategoryFailure, fetchQuestionscategoryRequest, fetchQuestionscategorySuccess } from '../redux/FetchQuestionsCategory/QuestionsCategoryAction';
import { addEifFailure, addEifRequest, addEifSuccess } from '../redux/AddEIF/AddEIFAction';
import { addRafFailure, addRafRequest, addRafSuccess } from '../redux/AddRAF/AddRAFAction';
import { fetchEifListFailure, fetchEifListRequest, fetchEifListSuccess } from '../redux/FetchEIFList/EIFListAction';
import { fetchRafListFailure, fetchRafListRequest, fetchRafListSuccess } from '../redux/FetchRAFList/RAFListAction';
import { checkDomainFailure, checkDomainSuccess, checkDomainRequest } from '../redux/CheckDomain/CheckDomainAction';
import { addUsersFailure, addUsersRequest, addUsersSuccess } from '../redux/AddUsers/AddUsersAction';
import { getUsersFailure, getUsersRequest, getUsersSuccess } from '../redux/GetUsers/GetUsersAction';

import { getTestersRequest, getTestersSuccess, getTestersFailure, getExistingTesterRequest, getExistingTesterSuccess, getExistingTesterFailure } from '../redux/Testers/TestersAction';
import { getDashboardRequest, getDashboardSuccess, getDashboardFailure, saveDashboardRequest, saveDashboardSuccess, saveDashboardFailure, publishDashboardRequest, publishDashboardSuccess, publishDashboardFailure, deleteDashboardRequest, deleteDashboardSuccess, deleteDashboardFailure } from '../redux/Dashboard/DashBoardAction';

import { getOrganizationsFailure, getOrganizationsRequest, getOrganizationsSuccess } from '../redux/GetOrganizations/GetOrganizationsAction';
import { addOrganizationsFailure, addOrganizationsRequest, addOrganizationsSuccess } from '../redux/AddOrganization/AddOrganizationsAction';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { update } from '../redux/login/loginAction';
import { clearUser } from '../redux/login/loginAction';
import { store } from '../App';


export const baseApiUrl = process.env.REACT_APP_BASE_API_URL;
export const OrgbaseApiUrl = process.env.REACT_APP_LOGIN_API_URL;
export const OriginServerName = process.env.REACT_APP_STATIC_SERVER_NAME;

const refreshAuthLogic = async (failedRequest) => {
    //  const { store } = store
    const userState = store.getState().user;
    const currentUser = userState.user;
    if (!userState) {
        return Promise.reject();
    }
    const tokenRefreshResponse = await axios.post(`${baseApiUrl}/admin/refresh/`, {
        refresh: currentUser.refreshToken
    });
    localStorage.setItem('refreshtoken', tokenRefreshResponse.data.token);
    const accessToken = tokenRefreshResponse.data.access_token;

    store.dispatch(
        update({
            user: {
                ...currentUser,
                accessToken
            }
        })
    );
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.token;
    return Promise.resolve();
};

createAuthRefreshInterceptor(axios, refreshAuthLogic);

export const login = async (email, password) => {
    const { dispatch } = store;
    try {
        dispatch(fetchUsersRequest);
        const response = await axios.post(`${baseApiUrl}/admin/login`, { username: email, password: password });

        if (response?.data?.hasOwnProperty('response')) {
            const { count_down } = response.data.response;
            const user = {
                email,
                count_down: count_down ? count_down : 0
            };

            // localStorage.setItem('refreshToken', response.data.response.token);
            // localStorage.setItem('user_role', response.data.response.role_type);
            localStorage.removeItem('forgotPassword');

            dispatch(fetchUsersSuccess(user));
        }

        return response;
    } catch (error) {
        dispatch(fetchUsersFailure(error.message));
        throwError(error);
    }
};

export const verifyOTP = async (email, otp) => {
    const { dispatch } = store;
    try {
        dispatch(fetchUsersRequest);
        const response = await axios.post(`${baseApiUrl}/admin/verify-otp/`, { username: email, otp: otp });

        const { token, user_id, role_type, is_pwd_updated, is_pwd_expired, pwd_expires_in, count_down, name } = response.data.response;
        const user = {
            email,
            token,
            name,

            user_id,
            role_type: role_type,
            is_pwd_updated: is_pwd_updated,
            is_pwd_expired: is_pwd_expired,
            pwd_expires_in: pwd_expires_in,
            count_down: count_down ? count_down : 0
        };

        localStorage.setItem('refreshToken', response.data.response.token);
        localStorage.setItem('user_role', response.data.response.role_type);
        localStorage.removeItem('forgotPassword');

        dispatch(fetchUsersSuccess(user));
        return response;
    } catch (error) {
        dispatch(fetchUsersFailure(error.message));
        throwError(error);
    }
};

export const preLogin = async () => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.email ? store.getState().loginData.user.email : '';

    const formData = new FormData();
    formData.append('username', currentUser);
    try {
        const preUserinfo = {
            email: currentUser,
            count_down: 0
        };
        dispatch(fetchPreLoginRequest(preUserinfo));
        const response = await axios.post(`${baseApiUrl}/admin/pre-login-check`, formData);
        const user = {
            email: currentUser,
            count_down: response.data.response.count_down
        };
        dispatch(fetchPreLoginSuccess(user));
        return response.data;
    } catch (error) {
        dispatch(fetchPreLoginFailure(error.message));
        throwError(error);
    }
};

export const forgotPassWord = async (email_id) => {
    const { dispatch } = store;

    try {
        return await axios.get(`${baseApiUrl}/admin/forgot-password?email_id=${email_id}`).then((response) => {
            return response.data;
        });
    } catch (error) {
        console.log('error');
        dispatch(checkDomainFailure(error.message));
        throwError(error);
    }
};

export const UpdateDomain = async (id, domain, isUpdated) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        if (isUpdated) {
            return await axios
                .put(
                    `${baseApiUrl}/after-raf/`,
                    { customer: id, domain: domain },
                    {
                        headers: {
                            Authorization: `Bearer ${currentUser}`
                        }
                    }
                )
                .then((response) => {
                    return response.data;
                });
        } else {
            return await axios
                .post(
                    `${baseApiUrl}/after-raf/`,
                    { customer: id },
                    {
                        headers: {
                            Authorization: `Bearer ${currentUser}`
                        }
                    }
                )
                .then((response) => {
                    return response.data;
                });
        }
    } catch (error) {
        console.log('error');
        dispatch(checkDomainFailure(error.message));
        throwError(error);
    }
};

export const checkDomain = async (domain) => {
    const { dispatch } = store;
    const data = `${domain}`;

    try {
        dispatch(checkDomainRequest);
        return await axios.post(`${baseApiUrl}/check/domain`, { domain: data }).then((response) => {
            const checkdomain = response.data;
            dispatch(checkDomainSuccess(checkdomain));
            return response.data;
        });
    } catch (error) {
        console.log('error');
        dispatch(checkDomainFailure(error.message));
        throwError(error);
    }
};

export const resendRAF = async (payLoad) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(
                `${baseApiUrl}/resend-raf/`,
                payLoad,
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const saveClientConfigure = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(
                `${baseApiUrl}/client-config`,
                {
                    customer: data.customer,

                    sections: data.sections,
                    config_type: data.config_type,
                    sub_config_type: data.sub_config_type
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const saveConfig = response.data;
                return saveConfig;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const partialSaveClientConfigure = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(
                `${baseApiUrl}/partial-client-config`,
                {
                    customer: data.customer,

                    sections: data.sections,
                    config_type: data.config_type,
                    sub_config_type: data.sub_config_type
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const saveConfig = response.data;
                return saveConfig;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const loadPartialSaveClientConfigure = async (id, configType, subConfigType, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(
                `${baseApiUrl}/partial-client-config?customer=${id}&config_type=${configType}&sub_config_type=${subConfigType}`,
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const saveConfig = response.data;
                callBack(response.data);
                return saveConfig;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const uploadMLModelFiles = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
    Object.entries(data).forEach(([fieldName, value]) => {
        form.append(fieldName, value);
    });
    try {
        return await axios
            .post(
                `${baseApiUrl}/ml_file_assets`,
                form,
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const fileResponse = response.data;
                callBack(fileResponse)
                return fileResponse;
            });
    } catch (error) {
        console.log('error throw');
        throwError(error);
    }
};

export const fetchConfigureQuestions = async (id, configType, subConfigType) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .get(`${baseApiUrl}/client-config?customer=${id}&config_type=${configType}&sub_config_type=${subConfigType}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const questionsList = response.data;
                return questionsList;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const fetchQuestions = async (value) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(fetchQuestionsRequest);
        return await axios
            .get(`${baseApiUrl}/questions/?category=${value}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const questionsList = response.data;

                dispatch(fetchQuestionsSuccess(questionsList));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(fetchQuestionsFailure(error.message));
        throwError(error);
    }
};

export const fetchEmails = async () => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .get(`${baseApiUrl}/admin/email-statuses`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const fetchBillingStatus = async (id) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/billing-status/?customer=${id}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const bill = response.data;
                return bill;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const isPrediction = async (id) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${currentUser}`);

        const formdata = new FormData();
        formdata.append('customer', id);

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(`${baseApiUrl}/billing-status/`, requestOptions)
            .then((response) => response.text())
            .then((result) => console.log(result))
            .catch((error) => console.log('error', error));
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const Email_Credetials = async (org_id, email_id) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(
                `${baseApiUrl}/after-raf/`,
                { customer: org_id, send_to: 'customer', email_id: email_id },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const fetchAllRecords = async (id, sDate, EDate) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/orders/?customer=${id}&start_date=${sDate}&end_date=${EDate}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const getRecord = async (id) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/orders/${id}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const configureBilling = async (data, update) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        if (update) {
            return await axios
                .put(
                    `${baseApiUrl}/billing/${data.customer}/`,
                    {
                        billing_cycle: data.billing_cycle,
                        base_fare: data.base_fare,
                        other_fare_per_cycle: data.other_fare_per_cycle
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${currentUser}`
                        }
                    }
                )
                .then((response) => {
                    return response.data;
                });
        } else {
            return await axios
                .post(`${baseApiUrl}/billing/`, data, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    return response.data;
                });
        }
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const downloadAllRecords = async (id) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/download/?customer=${id}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const path = response.data.response;
                window.open(`${baseApiUrl}/${path}`);
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const getOrderDownload = async (id, sDate, eDate) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/download/?customer=${id}&start_date=${sDate}&end_date=${eDate}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const path = response.data.response;

                window.open(`${baseApiUrl}/${path}`);
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const downloadReportCSV = async (id) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/download/${id}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const path = response.data.response;
                window.open(`${baseApiUrl}/${path}`);
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const uploadLogo = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${currentUser}`);
        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: data,
            redirect: 'follow'
        };
        return await fetch(`${baseApiUrl}/logos`, requestOptions).then((response) => {
            const logo = response.json();
            return logo;
        });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const uploadHeaderColor = async (org_id, header_color) => {
    const currentUser = store.getState().loginData.user.token;
    let data = { customer: org_id, header_color: header_color };
    try {
        return await axios
            .post(`${baseApiUrl}/client-css`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const alterQuestions = async (srcI, desI) => {
    const currentUser = store.getState().loginData.user.token;
    const data = {
        parent_question: srcI,
        child_question_id: desI
    };
    return await axios.post(`${baseApiUrl}/questionsrelation/`, data, {
        headers: {
            Authorization: `Bearer ${currentUser}`
        }
    });
};

export const fetchUsers = async () => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(getUsersRequest());

        return await axios
            .get(`${baseApiUrl}/users/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const usersList = response.data;

                dispatch(getUsersSuccess(usersList));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(getUsersFailure(error.message));
        throwError(error);
    }
};
export const fetchTesters = async () => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(getTestersRequest());
        const response = await axios
            .get(`${baseApiUrl}/users/?role_based=Super Admin`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
        const testerList = response;
        dispatch(getTestersSuccess(testerList));

        return testerList;
    } catch (error) {
        console.log('error');
        dispatch(getTestersFailure(error.message));
        throwError(error);
    }
};
export const getCustomerDetails = async (id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(getExistingTesterRequest());
        const response = await axios
            .get(`${baseApiUrl}/customers/${id}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
        const existingTesterList = response.test_users;
        dispatch(getExistingTesterSuccess(existingTesterList));

        return existingTesterList;
    } catch (error) {
        dispatch(getExistingTesterFailure(error.message));
        console.log('error');
        throwError(error);
    }
};
export const saveTesters = async (Org_Id, email) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        let response = await axios.post(
            `${baseApiUrl}/assign-tester`,
            {
                customer: Org_Id,
                test_users: email
            },
            {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            }
        );

        return response.data;
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};
export const deleteTesters = async (Org_Id, email) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        let data = new FormData();
        data.append('customer', Org_Id);
        data.append('test_user', email);
        var config = {
            method: 'delete',
            url: `${baseApiUrl}/assign-tester`,
            headers: {
                Authorization: `Bearer ${currentUser}`
            },
            data: data
        };
        const response = await axios(config).then(function (response) {
            return response.data;
        });
        return response;
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const getDashboard = async (id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(getDashboardRequest());
        const response = await axios
            .get(`${baseApiUrl}/dashboard/?customer=${id}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });

        let getDashboardList = response;
        dispatch(getDashboardSuccess(getDashboardList));
        return response;
    } catch (error) {
        dispatch(getDashboardFailure(error.message));
        throwError(error);
    }
};

export const saveDashboard = async (dashboard, id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    id && delete dashboard.customer;
    try {
        dispatch(saveDashboardRequest());

        let response = id
            ? await axios
                .put(
                    `${baseApiUrl}/dashboard/${id}/`,
                    {
                        ...dashboard
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${currentUser}`
                        }
                    }
                )
                .then((response) => {
                    return response.data;
                })
            : await axios
                .post(
                    `${baseApiUrl}/dashboard/`,
                    {
                        ...dashboard
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${currentUser}`
                        }
                    }
                )
                .then((response) => {
                    return response.data;
                });

        let dashboardList = id ? '' : response.response;
        dispatch(saveDashboardSuccess(dashboardList));
        return response;
    } catch (error) {
        console.log('error while saving dashboard nalytics');
        dispatch(saveDashboardFailure(error.message));
        throwError(error);
    }
};

//Kid Report Configuration APIs
export const DownloadKidReportTemplate = async (callBack) => {
    const currentUser = store.getState().loginData.user.token;
    const { dispatch } = store;
    try {
        dispatch(downloadKidreportsRequest);
        return await axios.get(`${baseApiUrl}/report-template/${currentUser}/`, { responseType: 'blob' }).then((response) => {
            const blob = new Blob([response.data], {
                type: 'application/octet-stream'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let fileName = 'referral_report_template.docx';
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            const questionsList = response.data;
            callBack(response.data);
            dispatch(downloadKidreportsSuccess(true));
            return questionsList;
        });
    } catch (error) {
        dispatch(downloadKidreportsFailure(false));
        console.log('error');
        throwError(error);
    }
};

export const getKidReportsList = async (id, Config, subConfig) => {
    const currentUser = store.getState().loginData.user.token;
    const { dispatch } = store;
    try {
        dispatch(requestKidreportsListRequest());
        return await axios
            .get(`${baseApiUrl}/referralreports/?customer=${id}&config_type=${Config}&sub_config_type=${subConfig}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const notificationsList = response.data;
                dispatch(requestKidreportsListSuccess(response.data));
                return notificationsList;
            });
    } catch (error) {
        dispatch(requestKidreportsListFailure([]));
        console.log('error');
        throwError(error);
    }
};

export const AddKidReport = async (formData, uploadedFile) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
    Object.entries(formData).forEach(([fieldName, value]) => {
        if (fieldName === 'conditions' || fieldName === 'context') {
            form.append(fieldName, JSON.stringify(value));
        } else {
            form.append(fieldName, value);
        }
    });
    form.append('template_file', uploadedFile);
    try {
        dispatch(addKidreportsRequest);
        return await axios
            .post(`${baseApiUrl}/referralreports/`, form, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const addedNotifications = response.data;
                dispatch(addKidreportsSuccess(addedNotifications));
                return response.data;
            });
    } catch (error) {
        console.log(error, 'error');
        dispatch(addKidreportsFailure(error.message));
        throwError(error);
    }
};

export const getKidReportDetails = async (id, Config, subConfig) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/referralreports/${id}/?config_type=${Config}&sub_config_type=${subConfig}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const notificationDetails = response.data;
                return notificationDetails;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const UpdateKidReport = async (formData, id, uploadedFile) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
    Object.entries(formData).forEach(([fieldName, value]) => {
        if (fieldName === 'conditions' || fieldName === 'context') {
            form.append(fieldName, JSON.stringify(value));
        } else {
            form.append(fieldName, value);
        }
    });
    form.append('template_file', uploadedFile);
    try {
        dispatch(addKidreportsRequest);
        return await axios
            .put(`${baseApiUrl}/referralreports/${id}/`, form, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const addedKidreports = response.data;
                dispatch(addKidreportsSuccess(addedKidreports));
                return response.data;
            });
    } catch (error) {
        console.log(error, 'error');
        dispatch(addKidreportsFailure(error.message));
        throwError(error);
    }
};

export const DeleteKidReport = async (id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(deleteKidreportsRequest);
        let response = await axios
            .delete(`${baseApiUrl}/referralreports/${id}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => response.data);

        dispatch(deleteKidreportsSuccess());
        return response;
    } catch (error) {
        console.log('Delete Kid Report failed');
        dispatch(deleteKidreportsFailure);
        throwError(error);
    }
};

export const ActiveKidReport = async (id, Config, subConfig, active) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(publishKidreportsRequest());
        let response = await axios
            .patch(
                `${baseApiUrl}/referralreports/${id}/`,
                {
                    is_active: active,
                    config_type: Config,
                    sub_config_type: subConfig
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => response.data);

        dispatch(publishKidreportsSuccess());
        return response;
    } catch (error) {
        console.error('Kid report Activation/De Activation failed');
        dispatch(publishKidreportsFailure());
        throwError(error);
    }
};

export const FetchPreviewKidReport = async (id, file, Config, subConfig, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/preview-referral-report/${id}/${currentUser}/`, { responseType: 'blob' })
            .then((response) => {

                if (response?.data?.status === 'failed') {
                    callBack(null);
                } else {
                    const notificationDetails = response.data;
                    const blob = new Blob([response.data], {
                        type: 'application/octet-stream'
                    });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = `preview_${file}`;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    callBack(true);
                    return notificationDetails;
                }

            });
    } catch (error) {
        callBack(false)
        console.log('error');
        throwError(error);
    }
};

export const removeHiddenObject = (array) => {
    array.forEach((section) => {
        section.questions = section.questions.filter((ques) => ques.is_for_hiding !== 'yes');
    });

    return array;
};

//Notifications Configuration APIs
export const fetchConfiguredQuestionsForNotifications = async (id, configType, subConfigType) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/client-config?customer=${id}&config_type=${configType}&sub_config_type=${subConfigType}&form_for=notification`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                let questionsList = response.data;
                questionsList = removeHiddenObject(questionsList.response)
                return questionsList;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

//Audit logs retirve APIs
export const fetchAuditReportsList = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    let queryString = '';
    for (const [key, value] of Object.entries(data)) {
        if (value) {
            queryString = queryString + `${key}=${value}&`;
        }
    }
    try {
        return await axios

            .get(`${baseApiUrl}customer-logs/?${queryString}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                console.log(response)
                let auditReportList = response.data;
                return auditReportList;

            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const fetchRolesConfiguration = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    let queryString = '';
    for (const [key, value] of Object.entries(data)) {
        if (value) {
            queryString = queryString + `${key}=${value}&`;
        }
    }
    try {
        return await axios

            .get(`${baseApiUrl}org-role-permissions?${queryString}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                let rolesConfiguration = response.data;
                return rolesConfiguration;

            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const AddRolesConfiguration = async (formData) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    // const form = new FormData();

    try {
        return await axios
            .post(`${baseApiUrl}org-role-permissions`, formData, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const AddRolesConfiguration = response.data;
                return AddRolesConfiguration;
            });
    } catch (error) {
        console.log(error, 'error');
        throwError(error);
    }
};

export const AddNotification = async (formData) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
    Object.entries(formData).forEach(([fieldName, value]) => {
        if (fieldName === 'conditions' || fieldName === 'selections') {
            form.append(fieldName, JSON.stringify(value));
        } else {
            form.append(fieldName, value);
        }
    });
    try {
        dispatch(addNotificationsRequest);
        return await axios
            .post(`${baseApiUrl}/notifications/`, form, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const addedNotifications = response.data;
                dispatch(addNotificationsSuccess(addedNotifications));
                return response.data;
            });
    } catch (error) {
        console.log(error, 'error');
        dispatch(addNotificationsFailure(error.message));
        throwError(error);
    }
};

export const updateNotificationsOrder = async (formData) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
    Object.entries(formData).forEach(([fieldName, value]) => {
        if (fieldName === 'notifications') {
            form.append(fieldName, JSON.stringify(value));
        } else {
            form.append(fieldName, value);
        }
    });

    try {
        return await axios
            .post(`${baseApiUrl}notifications-order`, form, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const addedNotifications = response.data;
                return response.data;
            });
    } catch (error) {
        console.log(error, 'error');
        throwError(error);
    }
};

export const uploadNotificationConfiguration = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
     Object.entries(data).forEach(([fieldName, value]) => {
        form.append(fieldName, value);
    });
    try {
        return await axios
            .post(
                `${baseApiUrl}/notifications/`,
                form,
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const fileResponse = response.data;
                return fileResponse;
            });
    } catch (error) {
        console.log('error throw');
        throwError(error);
    }
};

export const DownloadNotificationConfiguration = async (record) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .get(`${baseApiUrl}/notifications/${record.id}/?download=yes`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then(async (response) => {
                
                if (response?.data?.status === 'success') {

                    const { file_path } = response.data;

                    const fileResponse = await axios.get(
                        `${OrgbaseApiUrl}${file_path}`,
                        {
                            responseType: "blob",
                        }
                    );

                    const blob = new Blob([fileResponse.data], {
                        type: "application/json",
                    });

                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.download = file_path.split("/").pop();

                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    //window.open(`${OrgbaseApiUrl}/${response?.data?.file_path}`);
                }
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const UpdateNotification = async (formData, id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
    Object.entries(formData).forEach(([fieldName, value]) => {
        if (fieldName === 'conditions' || fieldName === 'selections') {
            form.append(fieldName, JSON.stringify(value));
        } else {
            form.append(fieldName, value);
        }
    });
    try {
        dispatch(addNotificationsRequest);
        return await axios
            .put(`${baseApiUrl}/notifications/${id}/`, form, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const addedNotifications = response.data;
                dispatch(addNotificationsSuccess(addedNotifications));
                return response.data;
            });
    } catch (error) {
        console.log(error, 'error');
        dispatch(addNotificationsFailure(error.message));
        throwError(error);
    }
};

export const getNotificationList = async (id, Config, subConfig) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/notifications/?customer=${id}&config_type=${Config}&sub_config_type=${subConfig}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const notificationsList = response.data;
                return notificationsList;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const getNotificationDetails = async (id, Config, subConfig) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/notifications/${id}/?config_type=${Config}&sub_config_type=${subConfig}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const notificationDetails = response.data;
                return notificationDetails;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const deleteNotification = async (id, Config, subConfig, customer) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
     
    try {
        dispatch(deleteNotificationsRequest);
        let response = await axios
            .delete(`${baseApiUrl}/notifications/${id}/?customer=${customer}&config_type=${Config}&sub_config_type=${subConfig}`, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
            .then((response) => response.data);

        dispatch(deleteNotificationsSuccess());
        return response;
    } catch (error) {
        console.log('Delete Notification failed');
        dispatch(deleteNotificationsFailure);
        throwError(error);
    }
};

export const publishnotifications = async (id, publish, Config, subConfig) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(publishNotificationsRequest());
        let response = await axios
            .patch(
                `${baseApiUrl}/notifications/${id}/`,
                {
                    is_published: publish,
                    config_type: Config,
                    sub_config_type: subConfig
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => response.data);

        dispatch(publishNotificationsSuccess());
        return response;
    } catch (error) {
        console.log('Notification Publish failed');
        dispatch(publishNotificationsFailure());
        throwError(error);
    }
};

export const publishDashboard = async (reportId, publish) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(publishDashboardRequest());
        let response = await axios
            .patch(
                `${baseApiUrl}/dashboard/${reportId}/`,
                {
                    is_published: publish
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => response.data);

        dispatch(publishDashboardSuccess());
        return response;
    } catch (error) {
        console.log('Dashboard Publish failed');
        dispatch(publishDashboardFailure());
        throwError(error);
    }
};

export const deleteDashboard = async (reportId) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(deleteDashboardRequest());
        let response = await axios
            .delete(`${baseApiUrl}/dashboard/${reportId}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => response.data);

        dispatch(deleteDashboardSuccess());
        return response;
    } catch (error) {
        console.log('Dashboard deleteDashboard failed');
        dispatch(deleteDashboardFailure());

        throwError(error);
    }
};

export const fetchOrganizations = async () => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(getOrganizationsRequest());

        return await axios
            .get(`${baseApiUrl}/customers/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const organizationsList = response.data;

                dispatch(getOrganizationsSuccess(organizationsList));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(getOrganizationsFailure(error.message));
        throwError(error);
    }
};

export const deleteOrganizations = async (customer, remove_type) => {
    const currentUser = store.getState().loginData.user.token;
    let data = {
        customer: customer
    };
    try {
        if (remove_type === 'delete') {
            return axios.delete(`${baseApiUrl}/customers/${customer}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            });
        } else {
            return axios.post(`${baseApiUrl}/customer/${remove_type.toLowerCase()}/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            });
        }
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const fetchEiflist = async () => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(fetchEifListRequest);
        return await axios
            .get(`${baseApiUrl}/staging?category=1`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const EifList = response.data;
                dispatch(fetchEifListSuccess(EifList));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(fetchEifListFailure(error.message));
        throwError(error);
    }
};

export const fetchRaflist = async (value, category) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    const subQuery = value ? `&q=${value}` : '';
    try {
        dispatch(fetchRafListRequest);
        return await axios
            .get(`${baseApiUrl}/staging?category=${category}${subQuery}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const RafList = response.data;
                dispatch(fetchRafListSuccess(RafList));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(fetchRafListFailure(error.message));
        throwError(error);
    }
};

export const fetchQuestionsCategory = async () => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(fetchQuestionscategoryRequest);
        return await axios
            .get(`${baseApiUrl}/questionscategory/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const questionscategoryList = response.data;
                dispatch(fetchQuestionscategorySuccess(questionscategoryList));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(fetchQuestionscategoryFailure(error.message));
        throwError(error);
    }
};

export const DeleteCategory = async (id, callBack) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        const response = await axios.delete(`${baseApiUrl}/questionscategory/${id}/`, {
            headers: {
                Authorization: `Bearer ${currentUser}`
            }
        });
        const data = response.data;
        if (typeof callBack === 'function') {
            callBack(data);
        }
        return data;
    } catch (error) {
        console.log('Delete Category failed');
        if (typeof callBack === 'function') {
            callBack([]);
        }
        throwError(error);
    }
};

export const AddQuestions = async (data, id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    if (id) {
        try {
            dispatch(addQuestionsRequest);
            return await axios
                .put(`${baseApiUrl}/questions/${id}/`, data, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    const addedquestions = response.data;
                    dispatch(addQuestionsSuccess(addedquestions));
                    return response.data;
                });
        } catch (error) {
            console.log('error');
            dispatch(addQuestionsFailure(error.message));
            throwError(error);
        }
    } else {
        try {
            dispatch(addQuestionsRequest);
            return await axios
                .post(`${baseApiUrl}/questions/`, data, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    const addedquestions = response.data;
                    dispatch(addQuestionsSuccess(addedquestions));
                    return response.data;
                });
        } catch (error) {
            console.log('error');
            dispatch(addQuestionsFailure(error.message));
            throwError(error);
        }
    }
};

export const TriggerIPFEmail = async (data) => {

    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(`${baseApiUrl}/stages/validate/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const AddUsers = async (data, id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    if (id) {
        try {
            dispatch(addUsersRequest);
            return await axios
                .put(`${baseApiUrl}/users/${id}/`, data, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    const addedusers = response.data;
                    dispatch(addUsersSuccess(addedusers));

                    return response.data;
                });
        } catch (error) {
            console.log('error');
            dispatch(addUsersFailure(error.message));
            throwError(error);
        }
    } else {
        try {
            dispatch(addUsersRequest);
            return await axios
                .post(`${baseApiUrl}/users/`, data, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    const addedusers = response.data;
                    dispatch(addUsersSuccess(addedusers));

                    return response.data;
                });
        } catch (error) {
            console.log('error');
            dispatch(addUsersFailure(error.message));
            throwError(error);
        }
    }
};

export const AddOrgUsers = async (data) => {
    // const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(`${baseApiUrl}/org/super/admins`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                console.log(response);
                return response.data;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const AddOrganizations = async (data, id) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    delete data.titleCount;
    delete data.error;
    const form = new FormData();
    Object.entries(data).forEach(([fieldName, value]) => {
        if (fieldName === 'referral_info') {
            form.append(fieldName, JSON.stringify(value));
        } else {
            form.append(fieldName, value);
        }
    });
    if (id) {
        try {
            dispatch(addOrganizationsRequest);

            return await axios
                .put(`${baseApiUrl}/customers/${id}/`, form, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    const addedOrganizations = response.data;
                    dispatch(addOrganizationsSuccess(addedOrganizations));

                    return response.data;
                });
        } catch (error) {
            console.log(error, 'error');
            dispatch(addOrganizationsFailure(error.message));
            throwError(error);
        }
    } else {
        try {
            dispatch(addOrganizationsRequest);
            form['gender'] = '2';
            return await axios
                .post(`${baseApiUrl}/customers/`, form, {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                })
                .then((response) => {
                    const addedOrganizations = response.data;
                    dispatch(addOrganizationsSuccess(addedOrganizations));

                    return response.data;
                });
        } catch (error) {
            console.log(error, 'error');
            dispatch(addOrganizationsFailure(error.message));
            throwError(error);
        }
    }
};

export const submitEIF = async (data) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(addEifRequest);
        return await axios
            .post(
                `${baseApiUrl}/staging`,
                {
                    category: 1,
                    answers: data,
                    is_completely_filled: 'true'
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const addeif = response.data;
                dispatch(addEifSuccess(addeif));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(addEifFailure(error.message));
        throwError(error);
    }
};

export const submitRAF = async (data, customer, category, is_completely_filled) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        dispatch(addRafRequest);
        return await axios
            .post(
                `${baseApiUrl}/staging`,
                {
                    category: category,
                    customer: customer,
                    answers: data,
                    is_completely_filled: is_completely_filled
                },
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const addraf = response.data;
                dispatch(addRafSuccess(addraf));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(addRafFailure(error.message));
        throwError(error);
    }
};

export const eifQuestions = async () => {
    const { dispatch } = store;
    try {
        dispatch(eifQuestionsRequest);
        await axios.get(`${baseApiUrl}/stages?category=1`).then((response) => {
            const loadquestions = response.data;
            dispatch(eifQuestionsSuccess(loadquestions));
            return response.data;
        });
    } catch (error) {
        console.log('error');
        dispatch(eifQuestionsFailure(error.message));
        throwError(error);
    }
};

export const rafQuestions = async (customer, category) => {
    const { dispatch } = store;
    try {
        dispatch(rafQuestionsRequest);
        return await axios.get(`${baseApiUrl}/stages?category=${category}&customer=${customer}`).then((response) => {
            const loadrafquestions = response.data;
            dispatch(rafQuestionsSuccess(loadrafquestions));
            return response.data;
        });
    } catch (error) {
        console.log('error');
        dispatch(rafQuestionsFailure(error.message));
        throwError(error);
    }
};

export const Org_Super_Admins = async (customer) => {
    // const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/org/super/admins?customer=${customer}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                return response.data;
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const AddQuestionsCategory = async (data) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;

    try {
        dispatch(addQuestionsCategoryRequest);
        return await axios
            .post(`${baseApiUrl}/questionscategory/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                const addquestionscategory = response.data;
                dispatch(addQuestionsCategorySuccess(addquestionscategory));
                return response.data;
            });
    } catch (error) {
        console.log('error');
        dispatch(addQuestionsCategoryFailure(error.message));
        throwError(error);
    }
};

export const UploadorDownloadAnswer = async (data) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .post(`${baseApiUrl}/bulk-answers`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (response?.data?.status === 'success' && response?.data?.response.includes('.csv')) {
                    window.open(`${OrgbaseApiUrl}/${response?.data?.response}`);
                }
                return response.data;
            });
    } catch (error) {
        console.log('error');

        throwError(error);
    }
};

export const DownloadToolConfiguration = async (id, configType, subConfigType) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .get(`${baseApiUrl}/client-config?customer=${id}&config_type=${configType}&sub_config_type=${subConfigType}&download`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then(async (response) => {
                if (response?.data?.status === 'success') {
                    const link = document.createElement('a');
                    const file = new Blob([JSON.stringify(response?.data?.response?.file_content, null, 2)], { type: 'application/json' });
                    link.href = URL.createObjectURL(file);
                    link.download = response?.data?.response?.file_name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const UploadToolConfiguration = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .post(`${baseApiUrl}/client-config`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const logOut = async () => {
    const { dispatch } = store;
    let token = localStorage.refreshToken ? (localStorage.refreshToken === undefined ? '' : localStorage.refreshToken === 'undefined' ? '' : localStorage.refreshToken) : '';
    let config = {
        method: 'post',
        url: `${baseApiUrl}/admin/logout`,
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    await axios(config).then((response) => {
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user_role');
        dispatch(clearUser());
        return response.data;
    });
};

export const UploadFile = async (data, uploadFileType, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    const urlKey = uploadFileType === "new" ? "upload-bulk-client-info" : "upload-mappings";
    try {
        return await axios
            .post(`${baseApiUrl}/${urlKey}/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const UpdateMappingFields = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .put(`${baseApiUrl}/upload-bulk-client-info/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const GetMappingFields = async (data, callBack) => {

    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/upload-bulk-client-info/?customer=${data.customer}&config_type=${data.config_type}&sub_config_type=${data.sub_config_type}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const uploadMappedConfiguration = async (data) => {
    const currentUser = store.getState().loginData.user.token;
    const form = new FormData();
     Object.entries(data).forEach(([fieldName, value]) => {
        form.append(fieldName, value);
    });
    try {
        return await axios
            .post(
                `${baseApiUrl}/upload-mappings/`,
                form,
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                const fileResponse = response.data;
                return fileResponse;
            });
    } catch (error) {
        console.log('error throw');
        throwError(error);
    }
};

export const DownloadMappedConfiguration = async (customer, config, subConfig) => {
    const currentUser = store.getState().loginData.user.token;

    try {
        return await axios
            .get(`${baseApiUrl}/upload-bulk-client-info/?customer=${customer}&config_type=${config}&sub_config_type=${subConfig}&download=yes`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then(async (response) => {
                
                if (response?.data?.status === 'success') {

                    const { file_path } = response.data;

                    const fileResponse = await axios.get(
                        `${OrgbaseApiUrl}${file_path}`,
                        {
                            responseType: "blob",
                        }
                    );

                    const blob = new Blob([fileResponse.data], {
                        type: "application/json",
                    });

                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.download = file_path.split("/").pop();

                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    //window.open(`${OrgbaseApiUrl}/${response?.data?.file_path}`);
                }
            });
    } catch (error) {
        console.log('error');
        throwError(error);
    }
};

export const RegisterCustomerApp = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(`${baseApiUrl}/external-apps/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const GetCustomerApp = async (data, callBack) => {
    const { dispatch } = store;
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/external-apps/?customer=${data.customer}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const DeleteCustomerApp = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .delete(`${baseApiUrl}/external-apps/${data.appId}/`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const UpdateCustomerApp = async (data, appId, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .put(`${baseApiUrl}/external-apps/${appId}/`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const RegenerateToken = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        let response = await axios
            .patch(
                `${baseApiUrl}/external-apps/${data.appId}/`, {},
                {
                    headers: {
                        Authorization: `Bearer ${currentUser}`
                    }
                }
            )
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });

        return response;
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const GetDependentAnswersTemplate = async (data, callBack) => {

    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/ans_deciders_config?customer=${data.customer}&config_type=${data.config}&sub_config_type=${data.subConfig}&question_id=${data.question_id}&deciders=${data.deciders}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    if (response?.data?.status === 'success' && response?.data?.response.includes('.csv')) {
                        window.open(`${OrgbaseApiUrl}/${response?.data?.response}`);
                    }
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const UploadConfiguredDependentAnswers = async (data, callBack) => {
    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .post(`${baseApiUrl}/ans_deciders_config`, data, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

export const DownloadConfiguredDependentAnswers = async (data, callBack) => {

    const currentUser = store.getState().loginData.user.token;
    try {
        return await axios
            .get(`${baseApiUrl}/ans_deciders_config?customer=${data.customer}&config_type=${data.config}&sub_config_type=${data.subConfig}&question_id=${data.question_id}`, {
                headers: {
                    Authorization: `Bearer ${currentUser}`
                }
            })
            .then((response) => {
                if (callBack) {
                    if (response?.data?.status === 'success' && response?.data?.response.includes('.csv')) {
                        window.open(`${OrgbaseApiUrl}/${response?.data?.response}`);
                    }
                    callBack(response.data);
                }
            });
    } catch (error) {
        console.log('error');
        if (callBack) {
            callBack(null);
        }
        throwError(error);
    }
};

// ---
// OrgDocument API functions for resource/document management
export const getOrgDocuments = async (orgId) => {
    try {
        const token = store.getState().loginData.user.token;
        const response = await axios.get(`${baseApiUrl}/org-documents?customer=${orgId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('getOrgDocuments error:', error.response?.data || error.message);
        throw error;
    }
};

export const uploadOrgDocument = async (formData) => {
    try {
        const token = store.getState().loginData.user.token;
        const response = await axios.post(`${baseApiUrl}/org-documents`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('uploadOrgDocument error:', error.response?.data || error.message);
        throw error;
    }
};

export const updateOrgDocument = async (docId, data) => {
    try {
        const token = store.getState().loginData.user.token;
        const response = await axios.patch(`${baseApiUrl}/org-documents/${docId}`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('updateOrgDocument error:', error.response?.data || error.message);
        throw error;
    }
};

export const deleteOrgDocument = async (docId) => {
    try {
        const token = store.getState().loginData.user.token;
        const response = await axios.delete(`${baseApiUrl}/org-documents/${docId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('deleteOrgDocument error:', error.response?.data || error.message);
        throw error;
    }
};

export const downloadOrgDocument = async (docId, title) => {
    const token = store.getState().loginData.user.token;
    const response = await fetch(`${baseApiUrl}/org-documents/${docId}/serve`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`Download failed: ${response.status}`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = title || `document_${docId}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

function throwError(error) {
    if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status, 'status');
        console.log(error.response.headers);
        if (error.response.status === 403 || error.response.status === 401) {
            const { dispatch } = store;
            logOut();
            dispatch(clearUser());
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user_role');
            alert('These credentials are logged into another session on this site. Click “Ok” to logout');
            window.location.reload();
        } else {
            const errorResponse = {
                data: error.response.data || undefined,
                status: error.response.status || undefined
            };
            alert('Something went wrong. Please try again later.');
            throw errorResponse;
        }
    } else if (error.request) {
        console.log(error.request);
        const errorResponse = {
            data: { Error: 'unknown error occurred while contacting the server' },
            status: undefined
        };
        throw errorResponse;
    } else {
        console.log('Error', error.message);
    }
}

export default createAuthRefreshInterceptor;
